import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute.js';
import NotFound from './pages/NotFound.js';
import Login from './pages/Login.js';
import Homeslider from './pages/homeslider/homeslider.js';
import Speakers from './pages/speakers/Speakers.js';
import Abstractupload from './pages/abstractupload/abstractupload.js';
import Aboutus from './pages/aboutus/aboutus.js';
import Uploadanalytics from './pages/uploadanalytics/uploadanalytics.js';
import Seocontent from './pages/seocontent/seocontent.js';
import Sociallinks from './pages/sociallinks/sociallinks.js';
import Videosgallery from './pages/videosgallery/videosgallery.js';
import Webinarevent from './pages/webinarevent/webinarevent.js';
import Webinarqa from './pages/webinarqa/webinarqa.js';
import Webinarvideo from './pages/webinarvideo/webinarvideo.js';
import Webinarwelcomecontent from './pages/webinarwelcomecontent/webinarwelcomecontent.js';
import Welcomecontent from './pages/welcomecontent/welcomecontent.js';
import Pastconfaffilations from './pages/pastconfaffilations/pastconfaffilations.js';
import Pastconfreport from './pages/pastconfreport/pastconfreport.js';
import Pastwebinarreport from './pages/pastwebinarreport/pastwebinarreport.js';
import Guidelines from './pages/guidelines/guidelines.js';
import TermsAndConditions from './pages/termsandconditions/termsandconditions.js';
import Regaddons from './pages/regaddons/regaddons.js';
import Registrationcontent from './pages/registrationcontent/registrationcontent.js';
import Registrationdates from './pages/registrationdates/registrationdates.js';
import Registrationtypeslist from './pages/registrationtypeslist/registrationtypeslist.js';
import Footers from './pages/footer/footer.js';
import Webinarprogram from './pages/webinarprogram/webinarprogram.js';
import Homeevent from './pages/homeevent/homeevent.js';
import Scientificprogram from './pages/scientificprogram/scientificprogram.js';
import Mediapartners from './pages/mediapartners/mediapartners.js';
import Ocm from './pages/ocm/ocm.js';
import Pastconftestimonials from './pages/pastconftestimonials/pastconftestimonials.js';
// import Seoopengraphprotocol from './pages/seoopengraphprotocol/seoopengraphprotocol.js';
import Seoschemamarkup from './pages/seoschemamarkup/seoschemamarkup.js';
// import Seotwittercard from './pages/seotwittercard/seotwittercard.js';
import Venue from './pages/venue/venue.js';
import Brochureuploads from './pages/brochureuploads/brochureuploads.js';
import Testimonials from './pages/testimonials/testimonials.js';
import Supportingjournals from './pages/supportingjournals/supportingjournals.js';
import Sessions from './pages/sessions/sessions.js';
import Seoxmlsitemap from './pages/seoxmlsitemap/seoxmlsitemap.js';
import Pastconfproceedingsupload from './pages/pastconfproceedingsupload/pastconfproceedingsupload.js';
import Pastconfgallery from './pages/pastconfgallery/pastconfgallery.js';
import Homecontact from './pages/homecontact/homecontact.js';
import SampleTextEditor from './pages/sampleTextEditor/sampleTextEditor.js';
import RegistrationPriceSetup from './pages/registrationpricesetup/registrationpricesetup.js';
import Conferenceqa from './pages/conferenceqa/conferenceqa.js';
import Abstractqa from './pages/abstractqa/abstractqa.js'
import Pasteventseo from './pages/pasteventseo/pasteventseo.js';
import Seoreport from './pages/seoreport/seoreport.js';


import { ToastContainer } from 'react-toastify';
const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/speakers" element={<ProtectedRoute><Speakers /></ProtectedRoute>} />
      <Route path="/homeslider" element={<ProtectedRoute><Homeslider /></ProtectedRoute>} />
      <Route path="/conferenceqa" element={<ProtectedRoute><Conferenceqa /></ProtectedRoute>} />
      <Route path="/abstractqa" element={<ProtectedRoute><Abstractqa /></ProtectedRoute>} />
      <Route path="/abstractupload" element={<ProtectedRoute><Abstractupload /></ProtectedRoute>} />
      <Route path="/aboutus" element={<ProtectedRoute><Aboutus /></ProtectedRoute>} />
      <Route path="/uploadanalytics" element={<ProtectedRoute><Uploadanalytics /></ProtectedRoute>} />
      <Route path="/seocontent" element={<ProtectedRoute><Seocontent /></ProtectedRoute>} />
      <Route path="/sociallinks" element={<ProtectedRoute><Sociallinks /></ProtectedRoute>} />
      <Route path="/videosgallery" element={<ProtectedRoute><Videosgallery /></ProtectedRoute>} />
      <Route path="/webinarevent" element={<ProtectedRoute><Webinarevent /></ProtectedRoute>} />
      <Route path="/webinarqa" element={<ProtectedRoute><Webinarqa /></ProtectedRoute>} />
      <Route path="/webinarvideo" element={<ProtectedRoute><Webinarvideo /></ProtectedRoute>} />
      <Route path="/webinarwelcomecontent" element={<ProtectedRoute><Webinarwelcomecontent /></ProtectedRoute>} />
      <Route path="/welcomecontent" element={<ProtectedRoute><Welcomecontent /></ProtectedRoute>} />
      <Route path="/pastconfaffilations" element={<ProtectedRoute><Pastconfaffilations /></ProtectedRoute>} />
      <Route path="/pastconfreport" element={<ProtectedRoute><Pastconfreport /></ProtectedRoute>} />
      <Route path="/pastwebinarreport" element={<ProtectedRoute><Pastwebinarreport /></ProtectedRoute>} />
      <Route path="/guidelines" element={<ProtectedRoute><Guidelines /></ProtectedRoute>} />
      <Route path="/termsAndConditions" element={<ProtectedRoute><TermsAndConditions /></ProtectedRoute>} />
      <Route path="/regaddons" element={<ProtectedRoute><Regaddons /></ProtectedRoute>} />
      <Route path="/registrationcontent" element={<ProtectedRoute><Registrationcontent /></ProtectedRoute>} />
      <Route path="/registrationdates" element={<ProtectedRoute><Registrationdates /></ProtectedRoute>} />
      <Route path="/registrationtypeslist" element={<ProtectedRoute><Registrationtypeslist /></ProtectedRoute>} />
      <Route path="/webinarprogram" element={<ProtectedRoute><Webinarprogram /></ProtectedRoute>} />
      <Route path="/brochureuploads" element={<ProtectedRoute><Brochureuploads /></ProtectedRoute>} />
      <Route path="/homeevent" element={<ProtectedRoute><Homeevent /></ProtectedRoute>} />
      <Route path="/scientificprogram" element={<ProtectedRoute><Scientificprogram /></ProtectedRoute>} />
      <Route path="/mediapartners" element={<ProtectedRoute><Mediapartners /></ProtectedRoute>} />
      <Route path="/ocm" element={<ProtectedRoute><Ocm /></ProtectedRoute>} />
      <Route path="/pastconftestimonials" element={<ProtectedRoute><Pastconftestimonials /></ProtectedRoute>} />
      {/* <Route path="/seoopengraphprotocol" element={<ProtectedRoute><Seoopengraphprotocol /></ProtectedRoute>} /> */}
      <Route path="/seoschemamarkup" element={<ProtectedRoute><Seoschemamarkup /></ProtectedRoute>} />
      <Route path="/pasteventseo" element={<ProtectedRoute><Pasteventseo /></ProtectedRoute>} />
      <Route path="/seoreport" element={<ProtectedRoute><Seoreport /></ProtectedRoute>} />
      {/* <Route path="/seotwittercard" element={<ProtectedRoute><Seotwittercard /></ProtectedRoute>} /> */}
      <Route path="/venue" element={<ProtectedRoute><Venue /></ProtectedRoute>} />
      <Route path="/testimonials" element={<ProtectedRoute><Testimonials /></ProtectedRoute>} />
      <Route path="/supportingjournals" element={<ProtectedRoute><Supportingjournals /></ProtectedRoute>} />
      <Route path="/sessions" element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
      <Route path="/seoxmlsitemap" element={<ProtectedRoute><Seoxmlsitemap /></ProtectedRoute>} />
      <Route path="/pastconfproceedingsupload" element={<ProtectedRoute><Pastconfproceedingsupload /></ProtectedRoute>} />
      <Route path="/pastconfgallery" element={<ProtectedRoute><Pastconfgallery /></ProtectedRoute>} />
      <Route path="/homecontact" element={<ProtectedRoute><Homecontact /></ProtectedRoute>} />
      <Route path="/footers" element={<ProtectedRoute><Footers /></ProtectedRoute>} />
      <Route path="/sampleTextEditor" element={<ProtectedRoute><SampleTextEditor /></ProtectedRoute>} />
      <Route path="/regpricesetup" element={<ProtectedRoute><RegistrationPriceSetup /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <ToastContainer />
  </Router>
);
export default AppRoutes;